/* "ALREADY GONE" -- ONE rule for a delete whose record is no longer there (Brian, 2026-10-02).

   Since the tenant-isolation fix the server answers a delete of an employee or vendor this company no
   longer has -- deleted on another tab, by another user, or never this company's -- with 404
   {"error":"Not found"} (server.js ownedBy). The operator asked for the record to be gone and it is gone,
   so a 404 on a delete is treated as DONE: the row leaves the list, the model refreshes, and no error is
   shown. Any OTHER failure is a real one and is shown.

   Against a server without the fix a delete never answers 404, so this changes nothing there. */

export function isAlreadyGone(err) {
  return !!(err && err.response && err.response.status === 404);
}

/* The words for a request that really failed: the server's own message when it sent one. ONE rule for every
   failure a page shows (a delete, a save) -- W-103 (2026-10-02) shows a refused employee save with it too. */
export function failureText(err, fallback = "The request failed.") {
  const d = err && err.response && err.response.data;
  return String((d && (d.message || d.error)) || (err && err.message) || fallback);
}

/* The words for a delete that really failed. */
export function deleteFailureText(err) {
  return failureText(err, "The delete failed.");
}
